export type Bonus = {
  label: string;
  title: string;
  subtitle: string;
  description: string;
  image: string;
};
export type Faq = {
  question: string;
  answer: string;
};
export type Need = {
  label: string;
  color: string;
};
export type Step = {
  title: string;
  description: string;
};
export type Differentiator = {
  title: string;
  description: string;
};
export type ComparisonRow = {
  loose: string;
  kit: string;
};
export type IncludedItem = {
  title: string;
  description: string;
};
export type Moment = {
  need: string;
  title: string;
  description: string;
};
export type CardSlide = {
  title: string;
  need: string;
  image: string;
};
export type OfferItem = {
  title: string;
  description: string;
  value: string;
};

export const checkoutUrl = 'https://botiquin-espiritual.impultienda.ar/checkout';

export const launchOffer = {
  regularPrice: 'USD 64',
  price: 'USD 17',
  saveLabel: 'Ahorras USD 47',
  note: 'Precio de lanzamiento por tiempo limitado.'
};

export const cta = {
  label: 'QUIERO MI BOTIQUÍN ESPIRITUAL',
  short: 'QUIERO MI BOTIQUÍN',
  microcopy: 'Pago único · Acceso inmediato · PDF imprimible · Garantía de 7 días'
};

// Imágenes oficiales del producto.
export const productImages = {
  hero: 'https://cdn.magicpatterns.com/uploads/gbiaExs66T5JDF2GqLrmNc/01_botiquin_espiritual.jpg',
  heroAlt: 'Botiquín Espiritual: cajita imprimible con 50 tarjetas bíblicas sobre una mesa junto a una Biblia',
  included: 'https://cdn.magicpatterns.com/uploads/sxJbePsWTWS83Hwc4ZX1U6/ChatGPT_Image_22_sept_2026,_05_35_32_p.m..png',
  includedAlt: 'Todo lo que recibes hoy: Botiquín Espiritual con 50 tarjetas bíblicas, cajita imprimible y los 4 bonos',
  howItWorks: 'https://cdn.magicpatterns.com/uploads/ux1qNc3kZaFbGSRtEd4n1v/ChatGPT_Image_22_sept_2026,_06_37_15_p.m..png',
  howItWorksAlt: 'Cajita Botiquín Espiritual junto a tarjetas bíblicas con versículos de Filipenses 4:6, Mateo 11:28, Salmos 23:1 e Isaías 26:3',
  offer: 'https://cdn.magicpatterns.com/uploads/cVDJA7YdX9v9QRgiaYevUQ/ChatGPT_Image_23_sept_2026,_12_48_42_p.m..png',
  offerAlt: 'Botiquín Espiritual completo: cajita, 50 tarjetas bíblicas y los 4 bonos'
};

export const hero = {
  eyebrow: 'Una Palabra de Dios para cada necesidad',
  title: 'Botiquín Espiritual',
  subtitle: '50 tarjetas bíblicas para encontrar paz, fortaleza, confianza y esperanza justo cuando más lo necesitas.'
};

export const needs: Need[] = [
  { label: 'Paz', color: '#7fb3c9' },
  { label: 'Fortaleza', color: '#c97a3c' },
  { label: 'Confianza', color: '#5aa36b' },
  { label: 'Esperanza', color: '#d8b35a' },
  { label: 'Ansiedad y preocupación', color: '#8f6fc0' },
  { label: 'Momentos difíciles', color: '#b4544a' }
];

export const pain = {
  headline: '¿Hay días en los que necesitas sentir a Dios un poco más cerca?',
  points: [
    'Te despiertas con la mente llena de preocupaciones y no sabes por dónde empezar el día.',
    'Estás cansado y te cuesta encontrar las palabras para orar.',
    'Una decisión o una espera te llena de incertidumbre.',
    'Sabes que la Biblia tiene una respuesta, pero en ese momento no sabes dónde buscarla.'
  ],
  claim: 'En esos momentos, Su Palabra puede estar a mano.',
  close: 'No hace falta tener todo resuelto. Solo volver a poner tus pensamientos en Dios, un versículo a la vez.'
};

export const solution = {
  title: 'Tu Botiquín Espiritual: la Palabra de Dios, lista para cada momento',
  description: 'No es una lista de versículos sueltos. Es un sistema sencillo para que, cuando lo necesites, sepas exactamente dónde buscar.'
};

export const differentiators: Differentiator[] = [
  {
    title: 'Pensado por necesidad',
    description: 'Cada tarjeta responde a un momento concreto. No tienes que buscar entre cientos de versículos.'
  },
  {
    title: 'Siempre a mano',
    description: 'Una cajita en tu mesa de noche, tu cocina o tu escritorio. La Palabra, cerca cuando la necesitas.'
  },
  {
    title: 'Un momento con Dios',
    description: 'Cada tarjeta te invita a leer, reflexionar, orar y llevar esa Palabra contigo durante el día.'
  }
];

export const comparison: ComparisonRow[] = [
  {
    loose: 'Versículos guardados en capturas que después no encuentras',
    kit: 'Tarjetas ordenadas según lo que estás viviendo'
  },
  {
    loose: 'Buscar al azar justo cuando más lo necesitas',
    kit: 'Encontrar tu tarjeta en segundos con el Mapa de Emergencia'
  },
  {
    loose: 'Leer y seguir de largo',
    kit: 'Leer, reflexionar, orar y llevar la Palabra contigo'
  }
];

export const steps: Step[] = [
  {
    title: 'Identifica',
    description: 'Piensa qué necesita hoy tu corazón: paz, fortaleza, confianza o esperanza.'
  },
  {
    title: 'Encuentra',
    description: 'Busca en tu Botiquín la tarjeta que acompaña ese momento.'
  },
  {
    title: 'Lee',
    description: 'Lee el versículo con calma. Deja que la Palabra te hable.'
  },
  {
    title: 'Reflexiona y ora',
    description: 'Tómate un minuto para pensar qué te dice hoy y conversarlo con Dios.'
  },
  {
    title: 'Llévala contigo',
    description: 'Guarda la tarjeta en tu bolso o en tu escritorio y vuelve a leerla durante el día.'
  }
];

export const included: IncludedItem[] = [
  {
    title: '50 tarjetas bíblicas imprimibles',
    description: 'Versículos seleccionados para los momentos en los que más necesitas una Palabra de Dios.'
  },
  {
    title: 'Cajita “Botiquín Espiritual” imprimible',
    description: 'Para guardar tus tarjetas juntas y tenerlas siempre a mano en casa.'
  }
];

export const includedFacts = ['Material digital en PDF', 'Lo imprimes en casa'];

// Muestras de tarjetas para el carrusel. Se muestra solo cuando hay imágenes cargadas.
export const cardSlides: CardSlide[] = [];

export const bonuses: Bonus[] = [
  {
    label: 'Bono #1',
    title: 'Mapa de Emergencia Espiritual',
    subtitle: 'Encuentra en segundos una Palabra de Dios para lo que estás viviendo hoy.',
    description: 'Una guía práctica para saber qué tarjetas leer cuando necesitas paz, fortaleza, confianza, esperanza o acompañamiento en un momento difícil.',
    image: 'https://cdn.magicpatterns.com/uploads/u2E5DP1d5XnvJpQaUTowmA/02_bono_1_mapa_emergencia.png'
  },
  {
    label: 'Bono #2',
    title: 'Rutina 7 Minutos de Paz',
    subtitle: 'Haz una pausa, conecta con Dios y vuelve a tu día con mayor paz.',
    description: 'Una guía paso a paso para leer Su Palabra, reflexionar, orar y convertir tus tarjetas en un momento diario con Dios.',
    image: 'https://cdn.magicpatterns.com/uploads/2VbPqWf3iuy4rYQrqe3WR9/03_bono_2_rutina_7_minutos.png'
  },
  {
    label: 'Bono #3',
    title: 'Declaraciones de Fe para Momentos Difíciles',
    subtitle: 'Para los días en los que necesitas fortalecer tu fe.',
    description: 'Palabras breves basadas en la Biblia, listas para leer en voz alta y llevar Su Palabra a tus pensamientos y a tu día.',
    image: 'https://cdn.magicpatterns.com/uploads/gMXJ6bTD2aPYqqE7L18AyC/04_bono_3_declaraciones_fe.png'
  },
  {
    label: 'Bono #4',
    title: 'Rincón de Paz en Casa',
    subtitle: 'Un pequeño lugar especial para encontrarte con Dios.',
    description: 'Cómo preparar ese rincón, tener tu Botiquín siempre a mano y crear un momento de lectura, reflexión y oración.',
    image: 'https://cdn.magicpatterns.com/uploads/c7MAVvPZjT6HRbVrWtBFFf/05_bono_4_rincon_de_paz.png'
  }
];

export const moments: Moment[] = [
  {
    need: 'Paz',
    title: 'Al empezar el día',
    description: 'Antes de mirar el teléfono, una tarjeta para poner tus pensamientos en Dios.'
  },
  {
    need: 'Ansiedad y preocupación',
    title: 'Cuando la mente no se detiene',
    description: 'Una Palabra para soltar lo que no puedes controlar y dejarlo en Sus manos.'
  },
  {
    need: 'Fortaleza',
    title: 'Antes de algo importante',
    description: 'Una entrevista, un trámite, una conversación difícil. Lleva la tarjeta contigo.'
  },
  {
    need: 'Confianza',
    title: 'Frente a una decisión',
    description: 'Para recordar que no caminas solo mientras esperas una respuesta.'
  },
  {
    need: 'Momentos difíciles',
    title: 'Cuando alguien que amas lo necesita',
    description: 'Comparte una tarjeta con un familiar o un amigo que está atravesando un momento duro.'
  },
  {
    need: 'Esperanza',
    title: 'Al terminar el día',
    description: 'Un versículo y una oración breve para descansar agradecido.'
  }
];

export const offerStack = {
  title: 'Tu Botiquín Espiritual completo',
  items: [
    {
      title: 'Botiquín Espiritual',
      description: '50 tarjetas bíblicas imprimibles',
      value: 'USD 19'
    },
    {
      title: 'Cajita imprimible',
      description: 'para guardar tus tarjetas siempre a mano',
      value: 'USD 7'
    },
    {
      title: 'Bono #1 · Mapa de Emergencia Espiritual',
      description: 'tu tarjeta en segundos',
      value: 'USD 12'
    },
    {
      title: 'Bono #2 · Rutina 7 Minutos de Paz',
      description: 'un momento diario con Dios',
      value: 'USD 9'
    },
    {
      title: 'Bono #3 · Declaraciones de Fe',
      description: 'para momentos difíciles',
      value: 'USD 9'
    },
    {
      title: 'Bono #4 · Rincón de Paz en Casa',
      description: 'tu lugar para encontrarte con Dios',
      value: 'USD 8'
    }
  ] as OfferItem[]
};

export const offerHighlights = ['PDF listo para imprimir', '4 bonos incluidos', 'Acceso inmediato', 'Imprímelo las veces que quieras'];

export const guarantee = {
  title: 'Pruébalo con tranquilidad durante 7 días',
  body: 'Descarga tu Botiquín Espiritual, imprímelo y úsalo en casa. Si sientes que no es para ti, te devolvemos el 100% de tu pago.',
  claim: 'Sin preguntas y sin complicaciones.'
};

export const faqs: Faq[] = [
  {
    question: '¿Es un producto físico o digital?',
    answer: 'Es 100% digital. Recibes los archivos en PDF para imprimir en tu casa o en una imprenta. No se envía nada por correo postal.'
  },
  {
    question: '¿Cómo lo recibo?',
    answer: 'Después del pago te llega un correo con el enlace de descarga, por lo general en pocos minutos. Revisa también la carpeta de spam o promociones.'
  },
  {
    question: '¿Cómo lo imprimo?',
    answer: 'Puedes imprimirlo con cualquier impresora doméstica, en hoja A4 o carta. Te recomendamos papel un poco más grueso para las tarjetas y la cajita. Después solo recortas y armas.'
  },
  {
    question: '¿Qué tamaño tienen las tarjetas?',
    answer: 'Las tarjetas vienen varias por hoja, en un tamaño práctico para guardar en la cajita, en tu bolso o en tu Biblia.'
  },
  {
    question: '¿Puedo volver a imprimirlo?',
    answer: 'Sí. El archivo es tuyo, así que puedes volver a imprimir tus tarjetas cada vez que quieras para tu uso personal o para regalar a tu familia.'
  },
  {
    question: '¿Cómo accedo después de comprar?',
    answer: 'Desde el enlace del correo puedes descargar todo cuando quieras. Te sugerimos guardar los PDF en tu teléfono o computadora para tenerlos siempre disponibles.'
  }
];
